<div class="p-progress-bar-container">
  <div class="p-progress-bar" [style.width]="value + '%'" [style.background-color]="color"></div>
</div>
